import "./index.css";
import "./config";

import App from "./App";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import { store } from "./store";

const div = document.getElementById("root");
if (div) {
  const root = ReactDOM.createRoot(div);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
}
